const sections2: string[] = [
  "CLASSIC",
  "PULVER - UV GEL SYSTEM",
  "PERMANENT MAKE UP",
  "WIMPERNVERLÄNGERUNG",
  "ZEHENMODELLAGEN",
  "SONSTIGE (SONDERWÜNSCHE NACH AUFWAND UND ABSPRACHE)"
];

export default sections2;